import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { WorkComponent } from '../components';
import { WorkService } from './work.service';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateWorkGuard implements CanDeactivate<WorkComponent> {
  constructor(private workSvc: WorkService) {}

  canDeactivate(
    component: WorkComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.workSvc.allowBack$.pipe(take(1));
  }
}
